// Action Types
export const FETCH_KEY_CONVERSATION_REQUEST = "FETCH_KEY_CONVERSATION_REQUEST";
export const FETCH_KEY_CONVERSATION_SUCCESS = "FETCH_KEY_CONVERSATION_SUCCESS";
export const FETCH_KEY_CONVERSATION_FAILURE = "FETCH_KEY_CONVERSATION_FAILURE";

// Action Creators
export const fetchKeyConversationRequest = (accountName) => {
  return (dispatch) => {
    dispatch({
      type: FETCH_KEY_CONVERSATION_REQUEST,
      payload: accountName,
    });
  };
};
export const fetchKeyConversationSuccess = (data) => ({
  type: FETCH_KEY_CONVERSATION_SUCCESS,
  payload: data,
});
export const fetchKeyConversationFailure = (error) => ({
  type: FETCH_KEY_CONVERSATION_FAILURE,
  payload: error,
});
